import getParameterNamesInSQLQueries from 'insights/parameters/data/getParameterNamesInSQLQueries';
import {RunQueryState} from 'insights/warehouse/AnalyticsWarehouseTypes';
import {AsyncStatus} from 'ui-library/hooks/useAsyncState';

export function getShouldShowRawSQLQuery({sqlQuery}: {sqlQuery: string}): boolean {
  const parameterNames = getParameterNamesInSQLQueries([sqlQuery]);
  const hasParameters = Boolean(parameterNames.length);
  // Only show raw SQL query if there are parameters. Otherwise it's the same as the one already in the SQL
  // code editor.
  return hasParameters;
}

export function getRawSQLQuery(runQueryState: RunQueryState): string | null {
  if (runQueryState.status === AsyncStatus.SUCCESS) {
    return runQueryState.data.rawSQLQuery;
  }
  if (runQueryState.status === AsyncStatus.ERROR) {
    const {invalidSQLQuery} = runQueryState.responseJSON as {invalidSQLQuery?: string};
    return invalidSQLQuery || null;
  }
  return null;
}
